import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { API_URL, API_URL_UPLOADS } from "./config";
import DashboardLayout from "./DashboardLayout/DasboardLayout";
function SearchTrip() {
  const [searchTerm, setSearchTerm] = useState("");
  const [trip, setTrip] = useState(null);
  const [chat, setChat] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [driver, setDriver] = useState(null);

  const APILINK = API_URL;

  const fetchTripData = async (tripId) => {
    try {
      const response = await fetch(`${APILINK}/trip/${tripId}`);
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      return data; // Return the fetched data
    } catch (error) {
      console.error("Failed to fetch trip data:", error);
      return []; // Return an empty array on error
    }
  };

  const fetchChatData = async (tripId) => {
    try {
      const response = await fetch(
        `${APILINK}/customer_driver_chats/customer_driver_chats/${tripId}`
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      return data.data || []; // Return the chat messages array
    } catch (error) {
      console.error("Failed to fetch chat data:", error);
      return []; // Return an empty array on error
    }
  };

  const fetchCustomerData = async (customerId) => {
    try {
      const response = await fetch(`${APILINK}/customerdetails/${customerId}`);
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      return data; // Return the customer data
    } catch (error) {
      console.error("Failed to fetch customer data:", error);
      return null; // Return null on error
    }
  };

  const fetchDriverData = async (driverId) => {
    try {
      const response = await fetch(`${APILINK}/driver/${driverId}`);
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      return data; // Return the driver data
    } catch (error) {
      console.error("Failed to fetch driver data:", error);
      return null; // Return null on error
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    const tripData = await fetchTripData(searchTerm);
    const chatData = await fetchChatData(searchTerm);

    setTrip(tripData.length > 0 ? tripData[0] : null);
    setChat(chatData.length > 0 ? chatData : null); // Set chat as the array of messages

    if (tripData.length > 0) {
      const tripInfo = tripData[0];
      const customerData = await fetchCustomerData(tripInfo.cust_id);
      const driverData = await fetchDriverData(tripInfo.driver_id);

      setCustomer(customerData[0]); // customerData is already an object
      setDriver(driverData[0]); // driverData is already an object
    }
  };

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-[#fff] text-white p-6">
        <div className="max-w-6xl mx-auto space-y-8">
          <h1 className="text-4xl font-bold text-center mb-12 text-[#002966] ">
            Search Trip Details
          </h1>

          <form onSubmit={handleSearch} className="mb-8">
            <div className="flex gap-2 max-w-md mx-auto">
              <input
                type="text"
                name="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search for Trip ID..."
                className="flex-1 px-4 py-2 rounded-lg bg-[#002966] border border-white/20 
                focus:outline-none focus:ring-2 focus:ring-white/30 text-white placeholder-white/50"
              />
              <button
                type="submit"
                className="px-6 py-2 bg-[#002966]  text-white rounded-lg hover:bg-white/90 
                transition-colors duration-200 flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </button>
            </div>
          </form>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {trip && (
              <div className="bg-[#002966] rounded-xl p-6 backdrop-blur-sm border border-white/20">
                <h2 className="text-2xl font-semibold mb-4">
                  Trip Information
                </h2>
                <div className="space-y-3">
                  <p>
                    <span className="font-medium">Trip ID:</span>{" "}
                    {trip.trip_id || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Customer ID:</span>{" "}
                    {trip.cust_id || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Driver ID:</span>{" "}
                    {trip.driver_id || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Origin:</span>{" "}
                    {trip.origin_location || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Destination:</span>{" "}
                    {trip.dest_location || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Status:</span>
                    <span
                      className={`ml-2 px-3 py-1 rounded-full text-sm
                    ${
                      trip.status === "Trip Ended"
                        ? "bg-green-500/20"
                        : "bg-yellow-500/20"
                    }`}
                    >
                      {trip.status || "N/A"}
                    </span>
                  </p>
                </div>
              </div>
            )}
            {trip && trip.status === "Trip Ended" && (
              <div className="bg-[#002966]  rounded-xl p-6 backdrop-blur-sm border border-white/20">
                <h2 className="text-2xl font-semibold mb-4">Feedback</h2>
                <div className="space-y-3">
                  <p>
                    <span className="font-medium">Customer Rating:</span>{" "}
                    {trip.customer_stars || "N/A"} ⭐
                  </p>
                  <p>
                    <span className="font-medium">Driver Rating:</span>{" "}
                    {trip.driver_stars || "N/A"} ⭐
                  </p>
                  <p>
                    <span className="font-medium">Driver Comment:</span>{" "}
                    {trip.driver_comment || "N/A"}
                  </p>
                  <p>
                    <span className="font-medium">Customer Comment:</span>{" "}
                    {trip.customer_comment || "N/A"}
                  </p>
                </div>
              </div>
            )}
            {customer && (
              <div className="bg-[#002966]  rounded-xl p-6 backdrop-blur-sm border border-white/20">
                <h2 className="text-2xl font-semibold mb-4">
                  Customer Information
                </h2>
                <div className="flex items-start space-x-4">
                  <img
                    src={`${API_URL_UPLOADS}/${customer.profilePic}`}
                    alt="Customer Profile"
                    className="w-40 h-40 rounded-full object-cover border-2 border-white/30"
                  />
                  <div className="space-y-3">
                    <p>
                      <span className="font-medium">Name:</span>{" "}
                      {customer.name || "N/A"} {customer.surname || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Status:</span>{" "}
                      {customer.membershipstatus || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">ID:</span>{" "}
                      {customer.customerid || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Rating:</span>{" "}
                      {customer.rating || "N/A"} ⭐
                    </p>
                  </div>
                </div>
              </div>
            )}

            {driver && (
              <div className="bg-[#002966] rounded-xl p-6 backdrop-blur-sm border border-white/20">
                <h2 className="text-2xl font-semibold mb-4">
                  Driver Information
                </h2>
                <div className="flex items-start space-x-4">
                  <img
                    src={`${API_URL_UPLOADS}/${driver.profilePic}`}
                    alt="Driver Profile"
                    className="w-20 h-20 rounded-full object-cover border-2 border-white/30"
                  />
                  <div className="space-y-3">
                    <p>
                      <span className="font-medium">Name:</span>{" "}
                      {driver.name || "N/A"} {driver.surname || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Status:</span>{" "}
                      {driver.membershipstatus || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">ID:</span>{" "}
                      {driver.driver_id || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Rating:</span>{" "}
                      {driver.rating || "N/A"} ⭐
                    </p>
                  </div>
                </div>
              </div>
            )}

            {chat && chat.length > 0 && (
              <div className="bg-[#002966]  rounded-xl p-6 backdrop-blur-sm border border-white/20">
                <h2 className="text-2xl font-semibold mb-4">Chat History</h2>
                <div className="space-y-3 max-h-96 overflow-y-auto">
                  {chat.map((msg) => (
                    <div
                      key={msg.customer_driver_chat_id}
                      className="p-3 bg-white/5 rounded-lg"
                    >
                      <p className="text-sm text-white/70">
                        {msg.date_chat} {msg.time_chat}
                      </p>
                      <p className="mt-1">{msg.message}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {trip === null && (
            <div className="text-center text-[#002966] ">No results found</div>
          )}
          {chat !== null && chat.length === 0 && (
            <div className="text-center text-[#002966] ">
              No chat results found
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default SearchTrip;
